import { render, staticRenderFns } from "./driverPoints.vue?vue&type=template&id=0eccfb18&scoped=true&"
import script from "./driverPoints.vue?vue&type=script&lang=js&"
export * from "./driverPoints.vue?vue&type=script&lang=js&"
import style0 from "./driverPoints.vue?vue&type=style&index=0&id=0eccfb18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eccfb18",
  null
  
)

export default component.exports